// Copyright (c) 2022 by Move Closer

import { ImageData, IRelatedService, ModuleContentResolver } from '../../contexts'
import { AttachmentsListModuleContent, AttachmentsListModuleContentInput, ResolvedListItem } from './AttachmentsList.contracts'
import { logger } from '../../support'
import { resolveImage } from '../resolvers'

/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
export const resolveAttachmentsListModuleContent: ModuleContentResolver<AttachmentsListModuleContentInput, AttachmentsListModuleContent> =
  async (input: AttachmentsListModuleContentInput, relatedService: IRelatedService): Promise<AttachmentsListModuleContent> => {
    let items: ResolvedListItem[] = []

    try {
      if (input.items && typeof input.items !== 'undefined') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        items = await Promise.all(input.items.map(async ({ file, ...rest }) => {
          let resolvedImage: ImageData | null = null

          if (file) {
            resolvedImage = await resolveImage(file, relatedService)
          }

          return {
            ...rest,
            file: resolvedImage
          }
        }))
      }
    } catch (e) {
      logger(e, 'warn')
    }

    return {
      ...input,
      items
    }
  }
